// extracted by mini-css-extract-plugin
export default {"menu_container":"MenuTabs_menu_container__fthXp","menu":"MenuTabs_menu__sEGzO"};